





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ImunisasiCheckboxGroup extends Vue {
  @Prop({ default: () => ({}) }) value!: any;

  localVal: any = this.initVal();

  initVal() {
    return {
      bcg: false, hb0: false, hb1: false, hb2: false, hb3: false,
      polio1: false, polio3: false,
      dpt1: false, dpt2: false, dpt3: false,
      campak: false, boster: false, lainnya: '',
      ...(this.value || {})
    };
  }

  @Watch('value', { deep: true })
  onValueChange() { this.localVal = this.initVal(); }

  emitChange() { this.$emit('input', { ...this.localVal }); }
}
